import React from 'react';
import './PageTabs.scss';

const PageTabs = ({ activeTab, setActiveTab, tabs }) => {
  return (
    <div className="page-tabs" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          className={
            activeTab === tab.id
              ? 'page-tabs__btn page-tabs__btn--active'
              : 'page-tabs__btn'
          }
          onClick={() => setActiveTab(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default PageTabs;
